/* This file is autogenerated, see readme.md for instructions */
import FireSvgIcon from '@bloomreach/banana-theme/icons/fire.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FireIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FireSvgIcon />
    </Icon>
  );
});

FireIcon.displayName = 'FireIcon';

export default FireIcon;
